import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchSerialReadyList = createAsyncThunk(
  "fetchSerialReadyList",
  async () => {
    const token = localStorage.getItem("auth_token");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    const response = await axiosHttp.get(`sn/list/warehouseIn`, config);

    return response.data.data;
  }
);

const SerialReadyListSlice = createSlice({
  name: "SerialReadyListSlice",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchSerialReadyList.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchSerialReadyList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchSerialReadyList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default SerialReadyListSlice.reducer;
